import styled from 'styled-components';

export const ReviewDate = styled.span`
  font-size: ${props => props.theme.font.custom(11)};
`;

export const ReviewTxt = styled.div`
  font-size: ${props => props.theme.font.custom(13)};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
  overflow: hidden;
  line-height: 1.3;
`;

export const ToolTip = styled.div`
  position: relative;
  cursor: pointer;
  .tip_top.right {
    left: 100%;
    transform: translate(-101%, 10px);
  }
  &:hover .tip_top {
    opacity: 1;
    pointer-events: auto;
  }
  &:hover .tip_top.right {
    transform: translate(-101%, 5px);
  }
  .tip {
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.3);
    transition: all 0.25s ease-out;
    display: block;
    /* margin-bottom: 15px; */
    opacity: 0;
    /* padding: 10px; */
    pointer-events: none;
    position: absolute;
    min-width: 250px;
    border-radius: 3px;
    z-index: 999999;

    line-height: 1.2;
  }
  .whiteBg {
    background: #fff;
    color: #666;
  }
  .tip_top:before,
  .tip_top:after {
    content: ' ';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -10px;
    border-left: solid transparent 10px;
    border-right: solid transparent 10px;
    transform: translateX(-50%);
  }
  .tip_top.right:before,
  .tip_top.right:after {
    left: 95%;
  }
  .tip_top:before {
    border-bottom: 10px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 1px;
  }
  .tip_top.whiteBg:after {
    border-bottom: solid #fff 10px;
  }
  .tip_top:after {
    z-index: 1;
  }
`;

export const PrgrsRt = styled.div`
  height: 7px;
  width: 80px;
  margin-bottom: 5px;
  margin-top: 3px;
  background: #ebebeb;
  border-radius: 10px;
`;

export const PrgrsWidth = styled.div`
  background: #2d67b2;
  height: 7px;
  border-radius: 10px;
`;

export const QuickTip = styled.div`
  padding: ${props => props.theme.spacing.custom(10)};
  background: #f5f5f5;
`;

export const ReviewHd = styled.div`
  font-size: ${props => props.theme.font.custom(14)};
`;

export const ReviewPer = styled.span`
  font-size: ${props => props.theme.font.custom(20)};
`;

export const ReviewContainer = styled.div`
  font-size: ${props => props.theme.font.custom(13)};
  width: 561px !important;
  height: 250px !important;
`;

export const ReviewSpc = styled.div`
  padding: ${props => props.theme.spacing.custom(10)} ${props => props.theme.spacing.custom(20)};
`;

export const ReviewTxtWrp = styled.div`
  border-right: 1px solid #e6e6e6;
  padding: ${props => props.theme.spacing.custom(10)} ${props => props.theme.spacing.custom(10)}
    ${props => props.theme.spacing.custom(10)} 0;
`;

export const Reviewer = styled.div`
  padding-bottom: ${props => props.theme.spacing.custom(10)};
`;

export const ReviewComment = styled.div`
  line-height: 1.5;
`;

export const ReviewRatingWrp = styled.div`
  padding: ${props => props.theme.spacing.custom(10)} ${props => props.theme.spacing.custom(20)};
`;

export const ListRating = styled.div`
  padding-bottom: ${props => props.theme.spacing.custom(10)};
`;

export const TipText = styled.div`
  font-size: 1.4rem;
`;

export const GoRating = styled.div`
  border: 1px solid #ccc;

  padding: 0 8px;
  margin-left: 2px;
  border-radius: 30px;
  margin-top: 2px;
  color: #666;
`;

export const GoRatingTxt = styled.div`
  color: #f26722;
  font-weight: 500;
  margin-left: 0;
  margin-right: 2px;
`;

export const Go = styled.div`
  width: 16px;
  height: 16px;
  background-color: #eb6628;
  color: #ffffff;
  border-radius: 50%;
  font-size: 10px;
`;
